import React, { useEffect } from "react";
import { DataGrid, deDE, GridColDef, GridRowParams, GridSortModel, LocalizationV4 } from "@material-ui/data-grid";
//import Tooltip from '@material-ui/core/Tooltip';
import Grid from "@material-ui/core/Grid";
import {
  Button,
  Container,
  FormControl,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  TextField,
  Typography,
  CircularProgress,
} from "@material-ui/core";

import { useAppSelector, useAppDispatch } from '../../../../app/hooks'
import {
  getRoutergeraettypen,
  selectRoutergeraettypListe,
  selectEditEntry,
  selectNewEntry,
  selectAktuellesRoutergeraettyp,
  selectViewMode,
  selectEditDirty,
  setEditEntry,
  updateAktuellesRoutergeraettyp,
  createRoutergeraettyp,
  updateRoutergeraettyp,
  setTyp,
  setHersteller,
  setKommentar,
  discardNew,
  discardChanges,
  startNewEntry,
  deleteRoutergeraettyp,
  setError,
  resetError,
  selectError,
  routergeraettypDummy,
  selectListLoading,
  selectSorting,
  setSorting,
  resetViewMode
} from "./routergeraettypenSlice";

import { useStyles } from "./../wertelisteStyles";
import { useMsal } from "@azure/msal-react";
import { routergeraettyp } from "../../../../utils/apiTypes";
import { rollen, isAuthorized } from "../../../../utils/auth/authConfig";
import { validate, validateHelper } from "../../../../features/validate/validate";
import { globalStyles } from "../../../../assets/globalStyles";


export const Routergeraettypen: React.FC = () => {
  const dispatch = useAppDispatch();
  const { instance } = useMsal();

  const rollenObj = rollen;

  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);

  useEffect(() => {
    dispatch(getRoutergeraettypen())
  }, [instance]);

  const classes = {
    ...useStyles(),
    ...globalStyles(),
  };

  const
    routergeraettypSelectListe: routergeraettyp[] = useAppSelector(selectRoutergeraettypListe),
    editEntry: boolean = useAppSelector(selectEditEntry),
    newEntry: boolean = useAppSelector(selectNewEntry),
    aktuellesRoutergeraettyp: routergeraettyp = useAppSelector(selectAktuellesRoutergeraettyp),
    viewMode: boolean = useAppSelector(selectViewMode),
    dirtyEdit: number = useAppSelector(selectEditDirty),
    inputError: boolean = useAppSelector(selectError),
    listLoading: boolean = useAppSelector(selectListLoading),
    sorting: GridSortModel = useAppSelector(selectSorting);

  const dataGridCols2: GridColDef[] = [
    { field: 'hersteller', headerName: 'Hersteller', flex: 2 },
    { field: 'typ', headerName: 'Typ', flex: 2 },
    { field: 'kommentar', headerName: 'Kommentar', flex: 2, filterable: false },
  ]

  function printTableRoutergeraettyp(data: routergeraettyp[]) {
    return (
      <Container maxWidth={false} className={classes.root}>
        <div style={{ height: "50vh", width: '100%' }}>
          <DataGrid
            localeText={(deDE as LocalizationV4).props.MuiDataGrid.localeText}
            disableColumnMenu={false}
            disableColumnSelector={true}
            columns={dataGridCols2}
            rows={data}
            sortModel={sorting}
            onSortModelChange={(model) => setSorting(model.sortModel)}
            onRowClick={(param: GridRowParams) => {
              let rt = routergeraettypDummy;
              const currentRT = data.find(mst => mst.id == (param.row.id as number))
              if (currentRT)
                rt = currentRT;
              if (!editEntry) dispatch(updateAktuellesRoutergeraettyp(rt));
            }}
            loading={listLoading} />
        </div>
      </Container>
    );
  }

  function printSaveDiscardButtons() {
    return (<div>
      <Button
        variant="contained"
        onClick={() => { newEntry ? dispatch(createRoutergeraettyp(aktuellesRoutergeraettyp)) : dispatch(updateRoutergeraettyp(aktuellesRoutergeraettyp)) }}
        color="secondary"
        className={classes.showtriButton}
        disabled={
          aktuellesRoutergeraettyp.typ == ""
          || aktuellesRoutergeraettyp.hersteller == ""
          || !dirtyEdit
          || inputError}
        style={{ minHeight: "36px" }}
      >
        {listLoading ? <CircularProgress size="20px" style={{ padding: "1px" }} /> : "Speichern"}
      </Button>
      <Button
        variant="contained"
        onClick={() => { newEntry ? dispatch(discardNew()) : dispatch(discardChanges()) }}
        color="secondary"
        className={classes.showtriButton}
      >
        Abbrechen
      </Button>
    </div>)
  }
  function confirmDeleteOfRoutergeraet() {
    dispatch(deleteRoutergeraettyp(aktuellesRoutergeraettyp));
    setOpenDeleteDialog(false);
  }

  function printEditDeleteButton() {
    if (isAuthorized([rollenObj.admin, rollenObj.betrieb]))
      return (
        <div>

          <Button
            variant="contained"
            onClick={() => dispatch(setEditEntry())}
            color="secondary"
            className={classes.showtriButton}
          >
            Bearbeiten
          </Button>
          {!aktuellesRoutergeraettyp.zugeordnet ?
            <Button
              variant="contained"
              onClick={() => setOpenDeleteDialog(true)}
              color="secondary"
              className={`${classes.backgroundColorErrorDark} ${classes.showtriButton}`}
            >
              Löschen
            </Button> : ""
          }
          <Dialog
            open={openDeleteDialog}
            onClose={() => setOpenDeleteDialog(false)}
          >
            <DialogTitle>Routerstelle löschen</DialogTitle>
            <DialogContent>
              <DialogContentText>
                {'Sind Sie sicher, dass Sie das Routergerättyp "' +
                  aktuellesRoutergeraettyp.typ +
                  '" wirklich löschen wollen?'}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                color="secondary"
                variant="contained"
                onClick={() => setOpenDeleteDialog(false)}
                className={classes.cancleDeleteButton}
              >
                Abbrechen
              </Button>
              <Button
                variant="contained"
                onClick={confirmDeleteOfRoutergeraet}
                className={classes.confirmDeleteButton}
                style={{ minWidth: "120px", minHeight: "36px" }}
              >
                {listLoading ? <CircularProgress size="20px" style={{ color: "black" }} /> : "Löschen"}
              </Button>
            </DialogActions>
          </Dialog>
          <Button
            variant="contained"
            onClick={() => { dispatch(resetViewMode()) }}
            color="default"
            className={classes.showtriButton}
          >
            Schließen
          </Button>
        </div>
      );
    else return (<React.Fragment />)
  }

  function printEdit() {
    return (
      <Paper className={classes.paper} style={{ marginLeft: "24px", marginRight: "24px", marginBottom: "10px" }}>
        <form className={classes.root} noValidate autoComplete="off" style={{ marginLeft: "16px", marginRight: "16px", marginBottom: "10px" }}>
          <div>
            <Grid container spacing={4}>
              <Grid item container xs={12}>
                <Grid item md={3}>
                  <Typography color="primary" variant="h6" className={classes.typoH6Style} component={"div"}>
                    {newEntry ? "Neues Routergerättyp anlegen" : "Bearbeiten von Routergerättyp: " + aktuellesRoutergeraettyp.typ}
                  </Typography>
                </Grid>
                <Grid item md={3} />
                <Grid item md={6} >
                  {editEntry ? printSaveDiscardButtons() : printEditDeleteButton()}
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={4}>
              <Grid item xs className={classes.justifyItems}>
                <FormControl className={classes.fullWidth}>
                  <TextField
                    required={true}
                    id="routergeraettyp-hersteller"
                    disabled={editEntry ? false : true}
                    label="Hersteller"
                    error={validate(dispatch, setError, resetError, aktuellesRoutergeraettyp.hersteller, "hersteller")}
                    helperText={validateHelper(aktuellesRoutergeraettyp.hersteller)}
                    variant="outlined"
                    onChange={(event) => dispatch(setHersteller(event.target.value))}
                    value={aktuellesRoutergeraettyp.hersteller}
                  />
                </FormControl>
              </Grid>
              <Grid item xs>
                <FormControl className={classes.fullWidth}>
                  <TextField
                    required={true}
                    id="routergeraettyp-typ"
                    disabled={editEntry ? false : true}
                    label="Typ"
                    error={validate(dispatch, setError, resetError, aktuellesRoutergeraettyp.typ, "typ")}
                    helperText={validateHelper(aktuellesRoutergeraettyp.typ)}
                    variant="outlined"
                    onChange={(event) => dispatch(setTyp(event.target.value))}
                    value={aktuellesRoutergeraettyp.typ}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Grid container spacing={4}>
              <Grid item xs>
                <FormControl className={classes.fullWidth}>
                  <TextField
                    disabled={editEntry ? false : true}
                    id="routergeraettyp-kommentar"
                    multiline
                    rows={4}
                    rowsMax={8}
                    label="Kommentar"
                    error={validate(dispatch, setError, resetError, aktuellesRoutergeraettyp.kommentar, "kommentar")}
                    helperText={validateHelper(aktuellesRoutergeraettyp.kommentar)}
                    variant="outlined"
                    onChange={(event) => dispatch(setKommentar(event.target.value))}
                    value={aktuellesRoutergeraettyp.kommentar ? aktuellesRoutergeraettyp.kommentar : ""}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </div>
        </form>
      </Paper>
    )
  }

  return (
    <div>
      {viewMode ? printEdit() : ""}
      <Paper className={classes.paper} style={{ marginBottom: "10px", marginLeft: "24px", marginRight: "24px" }}>
        <Grid container spacing={2} style={{ marginBottom: "10px", padding: "0px", paddingLeft: "0px", paddingRight: "0px" }}>
          <Grid item md={3} >
            <Typography color="primary" variant="h6" className={classes.typoH6Style} style={{ marginLeft: "20px" }} >
              Routertypen Übersicht
            </Typography>
          </Grid>
          <Grid item md={3} />
          <Grid item md={6} style={{ paddingRight: "24px", paddingTop: "0px" }}>
            <Grid item container md={12}>
              <Grid item md={3} />
              <Grid item md={3} />
              <Grid item md={3} />
              <Grid item md={3}>
                {isAuthorized([rollenObj.admin, rollenObj.betrieb]) ?
                  <Button
                    variant="contained"
                    onClick={() => dispatch(startNewEntry())}
                    color="secondary"
                    className={classes.showButton}
                    disabled={editEntry}
                  >
                    Hinzufügen
                  </Button>
                  : ""}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2} style={{ marginBottom: "20px" }}>
          {printTableRoutergeraettyp(routergeraettypSelectListe)}
        </Grid>
      </Paper>
    </div>
  );
}
